module.exports = __webpack_public_path__ + "img/map-step_3.5c5e16d.webp";